import { useState } from "react";

import { client } from "@/config/client";
import { useAppNotification } from "@/modules/app-notification";

import { handleExportSuccess, handleExportErrors } from "./importToolXSLX.util";

export const useExportDataset = (templateId) => {
  const [loading, setLoading] = useState(false);
  const { notify } = useAppNotification();

  const handleExportDataset = (model, params = {}) => {
    setLoading(true);

    return client[model]
      .exports(templateId, { ...params })
      .then(({ data }) => handleExportSuccess(data.data))
      .catch(({ response }) => handleExportErrors(response, notify))
      .finally(() => setLoading(false));
  };

  return { loading, handleExportDataset };
};
